import { render } from "./IconButton.vue?vue&type=template&id=73bf2b74&scoped=true"
import script from "./IconButton.vue?vue&type=script&lang=ts"
export * from "./IconButton.vue?vue&type=script&lang=ts"

import "./IconButton.vue?vue&type=style&index=0&id=73bf2b74&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-73bf2b74"

export default script